import AreaChartWidget from './area-chart.widget';
export default AreaChartWidget;
